goog.provide('el8.appchart.mainFeeds.plrNotification');

goog.require('el8.appchart.dialog.schedulePLRMassImport');
goog.require('el8.ptdata.plrCollaborators');
goog.require('el8.service.urls');
goog.require('el8.template.appchart.mainFeeds');
goog.require('el8.util.consts');

el8.appchart.mainFeeds.plrNotification = (function() {

    var lastReviewTime;
    var that = {};

    function updateNewCounts() {
        $.el8_ajax({
            type: 'GET',
            url: el8.service.urls.get('plrChartUpdates'),
            success: function(data) {
                // if there's no PLR collaborator, data would be null
                if (!data) {
                    $('#plr-notification-holder').empty();
                    $('#plr-notification-acknowledge-trigger').hide();
                    $('#plr-notification-container').hide();
                    return;
                }
                that.setLastReviewTime(data.latest_review_time);
                var counts = data.counts;
                that.lastReviewFeedItemIds = data['ids'];
                var totalCount = _.reduce(_.values(counts), function(memo, num) { return memo + num; }, 0);

                el8.appchart.refpanel.compareRefpanel.checkPlrProfileStatus(function(data) {
                    var hasCompareProfile = Boolean(data);
                    if (totalCount || hasCompareProfile) {
                        $('#plr-notification-container').show();
                        $('#plr-notification-holder').html(
                            el8.template.appchart.mainFeeds.plrPassiveNotification({
                                pairs: _.filter(_.pairs(counts), function(p) { return p[1] > 0; }),
                                compareProfile: hasCompareProfile
                            })
                        );
                    } else {
                        $('#plr-notification-holder').empty();
                        $('#plr-notification-container').hide();
                    }

                    if (totalCount) {
                        $('#plr-passive-notification-trigger').show();
                        $('#plr-notification-acknowledge-trigger').show();
                    } else {
                        $('#plr-passive-notification-trigger').hide();
                        $('#plr-notification-acknowledge-trigger').hide();
                    }
                    if (hasCompareProfile) {
                        $('#plr-notification-compare-trigger').show();
                    } else {
                        $('#plr-notification-compare-trigger').hide();
                    }
                });
            }
        });
    }

    function acknowledgeNewItems() {
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('plrChartUpdates'),
            success: function(data) {
                that.setLastReviewTime(data.latest_review_time);
                updateNewCounts();
            }
        });
        el8.util.amplitude.logPLRChronologicalRecordCollabView("Acknowledge");
    }

    $.extend(that, {

        init: function() {
            // If we don't have any collaborators, do nothing more
            if (!el8.ptdata.plrCollaborators.all().length) { return; }

            updateNewCounts();
            $('#plr-notification-container').on('click', '#plr-passive-notification-trigger',  function() {
                el8.appchart.mainFeeds.chart.doCareteamSearch();
                el8.util.amplitude.logPLRChronologicalRecordCollabView("Show");
            });
            $(document).on('click', '#plr-notification-acknowledge-trigger',  acknowledgeNewItems);
            $(document).on('click', '#plr-notification-compare-trigger',  function(event) {
                event.preventDefault();
                el8.appchart.refpanel.compareRefpanel.show();
                el8.util.amplitude.logPLRChronologicalRecordCollabView("Compare Profiles");
            });
            $(document).on('click', '#plr-sign-and-import-all-trigger',  function(event) {
                event.preventDefault();
                el8.appservice.notifier.notify('Signing all documents into your chart...');
                el8.appchart.dialog.schedulePLRMassImport.show();
                el8.util.amplitude.logPLRChronologicalRecordCollabView("Sign & Import All");
            });

            el8.appchart.dialog.schedulePLRMassImport.setPLRNotification(that);
        },

        getLastReviewTime: function() {
            if (lastReviewTime === undefined) {
                // We haven't fetched it yet. The user did a PLR search before
                // we fetched our new counts.
                $.el8_ajax({
                    type: 'GET',
                    async: false,
                    url: el8.service.urls.get('plrChartLastReviewTime'),
                    success: function(data) {
                        that.setLastReviewTime(data.latest_review_time);
                    }
                });
            }
            return lastReviewTime;
        },

        setLastReviewTime: function(serverDt) {
            lastReviewTime = el8.service.tz.newTzDateTime(serverDt);
        },

        getLastReviewFeedItemIds: function() {
            return this.lastReviewFeedItemIds;
        },

        refresh: function() {
            updateNewCounts();
        }

    });

    return that;

})();
